// extracted by mini-css-extract-plugin
module.exports = {"container":"page404-module__container","btn":"page404-module__btn","mobileHeader":"page404-module__mobileHeader"};